import React, { useState } from 'react';
import { UserPlus } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';

const EMPTY = { customer_name: '', contact_person: '', email: '', phone: '', billing_address: '', shipping_address: '' };

export const QuickAddCustomerButton = ({ api, onCreated, disabled, testId = 'quick-add-customer' }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async () => {
    if (!form.customer_name.trim()) { toast.error('Customer name is required'); return; }
    setSaving(true);
    try {
      const payload = Object.fromEntries(Object.entries(form).map(([k, v]) => [k, v.trim() || null]));
      const r = await api().post('/customers', payload);
      toast.success(`${r.data.customer_name} added to customers`);
      onCreated(r.data);
      setForm(EMPTY); setOpen(false);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not create customer'); }
    finally { setSaving(false); }
  };

  return (
    <>
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen(true)} disabled={disabled} className="rounded-sm h-9 shrink-0" data-testid={`${testId}-btn`}>
        <UserPlus className="w-3.5 h-3.5 mr-1" /> New
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid={`${testId}-dialog`}>
          <DialogHeader><DialogTitle>New Customer</DialogTitle></DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2"><Label>Customer Name *</Label><Input value={form.customer_name} onChange={set('customer_name')} className="rounded-sm" autoFocus data-testid={`${testId}-name`} /></div>
            <div><Label>Contact Person</Label><Input value={form.contact_person} onChange={set('contact_person')} className="rounded-sm" data-testid={`${testId}-contact`} /></div>
            <div><Label>Phone</Label><Input value={form.phone} onChange={set('phone')} className="rounded-sm mono" data-testid={`${testId}-phone`} /></div>
            <div className="col-span-2"><Label>Email</Label><Input type="email" value={form.email} onChange={set('email')} className="rounded-sm mono" data-testid={`${testId}-email`} /></div>
            <div className="col-span-2"><Label>Billing Address</Label><Textarea rows={2} value={form.billing_address} onChange={set('billing_address')} className="rounded-sm" data-testid={`${testId}-billing`} /></div>
            <div className="col-span-2"><Label>Shipping Address</Label><Textarea rows={2} value={form.shipping_address} onChange={set('shipping_address')} className="rounded-sm" data-testid={`${testId}-shipping`} /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} className="rounded-sm" data-testid={`${testId}-cancel`}>Cancel</Button>
            <Button onClick={save} disabled={saving} className="bg-slate-900 hover:bg-slate-800 rounded-sm" data-testid={`${testId}-save`}>{saving ? 'Saving…' : 'Save & Select'}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default QuickAddCustomerButton;
